import styled from 'styled-components';
import classNames from 'classnames';
import { forwardRef } from 'react';

const Wrap = styled.div`
  box-sizing: border-box;
  height: 100%;
  scroll-behavior: smooth;
  &::-webkit-scrollbar {
    background: transparent;
    width: 6px;
    height: 6px;
  }
  &::-webkit-scrollbar-corner {
    background: transparent;
  }

  /* 滚动槽--外层轨道 */

  &::-webkit-scrollbar-track {
    background: none;
  }

  /* 内层轨道（不包含滚动块部分） */

  &::-webkit-scrollbar-track-piece {
    opacity: 0; /* 透明度设置为全透明，使得滚动条背景色为网页颜色 */
  }

  /* 滚动条滑块 */

  &::-webkit-scrollbar-thumb {
    border-radius: 3px;

    //background: none;
    background: transparent;
  }
  &:hover::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.55);
  }

  &:active::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.7);
  }
  &._scrollDark {
    &::-webkit-scrollbar-thumb {
      background: rgba(0, 0, 0, 0.3);
    }
    &:active::-webkit-scrollbar-thumb {
      background: rgba(0, 0, 0, 0.45);
    }
  }
  &._overflowX {
    overflow-x: auto;
    overflow-y: hidden;
    margin-right: -6px;
    padding-right: 6px;
  }
  &._overflowY {
    overflow-y: auto;
    overflow-x: hidden;
    margin-bottom: -6px;
    padding-bottom: 6px;
  }
  &._overflow {
    overflow: auto;
  }
`;
const Inner = styled.div`
  //margin-right: -6px;
  //margin-bottom: -6px;
`;

const Scroll = forwardRef((props, ref) => {
  const {
    children,
    className = '',
    dark,
    margin = true,
    overflowX,
    overflowY,
    overflowAuto,
    ...rest
  } = props;

  return (
    <Wrap
      ref={ref}
      className={classNames(className, 'ui-scroll', {
        _scrollDark: dark,
        _overflowX: overflowX,
        _overflowY: overflowY,
        _overflow: overflowAuto,
      })}
      {...rest}
    >
      {margin ? <Inner>{children}</Inner> : children}
    </Wrap>
  );
});

export default Scroll;
